<template>
  <div>
    <v-card style="width:100%;padding:10px;">
      <v-layout row wrap style="height:40px;">
        <v-flex xs12 style="padding-top:8px">
          <v-btn class="success searchbtn" @click="fetchstatement">Search</v-btn>
          <v-menu
            :close-on-content-click="false"
            v-model="menu2"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date2"
              readonly
              class="search"
              placeholder="To Date"
            />
            <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            v-model="menu1"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date1"
              readonly
              class="search"
              placeholder="From Date"
            />
            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
          </v-menu>
          <input type="number" class="search" v-model="mobile" placeholder="Enter Number" />
        </v-flex>
        <v-layout row wrap>
          <v-spacer></v-spacer>
        </v-layout>
      </v-layout>
    </v-card>
    <v-data-table :headers="headers" :items="statementlist" :search="search">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.sender }}</td>
        <td>{{ props.item.mobile }}</td>
        <td>{{ props.item.bank_txtid }}</td>
        <td>{{ props.item.account }}</td>
        <td>{{ props.item.amount }}</td>
        <td>
          <v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn>
        </td>
        <td>{{ props.item.tid }}</td>
        <td>{{ props.item.time}}</td>
        <td>{{ props.item.remark }}</td>
        <td>
          <v-btn @click="getsummary(props.item)" small color="primary">View</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewstatus" width="950">
      <div class="printer__container">
        <div class="printer" ref="print">
          <div class="printer__header">
            <img src="../assets/logo.png" class="printer__image" alt />
            <p class="printer__title">Money Transfer Receipt</p>
            <img src="../assets/logo.png" class="printer__image" style="visibility:hidden" alt />
          </div>
          <table class="printer__table">
            <tr class="printer__tr printer__tr--title">
              <td>Sender Details</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="printer__tr">
              <td>Name</td>
              <td>{{summary.sender}}</td>
              <td>Mobile No</td>
              <td>{{summary.mobile}}</td>
            </tr>
            <tr class="printer__tr printer__tr--title">
              <td>Retailer Details</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="printer__tr">
              <td>Name</td>
              <td>{{summary.user_name}}</td>
              <td>Mobile No</td>
              <td>{{summary.mobile_no}}</td>
            </tr>
            <tr class="printer__tr printer__tr--title">
              <td>Beneficiary Details</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="printer__tr">
              <td>Bank Name</td>
              <td>{{summary.bank_name}}</td>
              <td>IFSC Code</td>
              <td>{{summary.bank_ifsc}}</td>
            </tr>
            <tr class="printer__tr">
              <td>Name</td>
              <td>{{summary.name}}</td>
              <td>Account No</td>
              <td>{{summary.account}}</td>
            </tr>
            <tr class="printer__tr printer__tr--title">
              <td>Transaction Details</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr class="printer__tr">
              <td>Total Amount</td>
              <td>{{summary.amount}}</td>
              <td>Date</td>
              <td>{{summary.time}}</td>
            </tr>
          </table>
          <table class="printer__table printer__table--border">
            <tr class="printer__tr">
              <td>Transaction Id</td>
              <td>Bank Transaction id</td>
              <td>Transaction Amount</td>
              <td>Status</td>
              <td>Amount</td>
            </tr>
            <tr class="printer__tr">
              <td>{{summary.tid}}</td>
              <td>{{summary.bank_txtid}}</td>
              <td>{{summary.amount}}</td>
              <td>{{summary.status}}</td>
              <td>{{summary.amount}}</td>
            </tr>
          </table>
        </div>
        <div class="printer__footer">
          <v-spacer />
          <v-btn color="red" dark @click="viewstatus = false">Cancel</v-btn>
          <v-btn color="primary" @click="print()">Print</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      modal: false,
      date1: moment().format("YYYY-MM-DD"),
      menu1: false,
      date2: moment().format("YYYY-MM-DD"),
      menu2: false,
      mobile: "",
      headers: [
        { text: "Order No", value: "orderno", align: "left" },
        { text: "Name", value: "name" },
        { text: "Sender Name", value: "sender" },
        { text: "MobileNo", value: "mobile" },
        { text: "Bank Transaction ID", value: "bank_txtid" },
        { text: "Account No", value: "account" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        { text: "TransactionID", value: "transactionid" },
        { text: "Recharge Time", value: "time" },
        { text: "Remark", value: "remark" },
        { text: "Action", value: "action" }
      ],
      dialog: false,
      viewstatus: false,
      statementlist: [],
      modal: false,
      search: "",
      summary: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    dmr() {
      return this.$store.getters.instapay;
    }
  },
  watch: {
    dmr(val) {
      console.log(val);
      if (val != null) {
        this.fetchstatement();
        this.mobile = val.mobile_no;
      }
    }
  },
  methods: {
    checkstatus(status) {
      status = status.toLowerCase();
      if (status == "success") return "success";
      if (status == "pending") return "grey";
      if (status == "inprocess") return "warning";
      if (status == "failed") return "error";
      return "primary";
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    pushstatement(value) {
      let vm = this;
      vm.statementlist = [];
      for (let i = 0; i < value.length; i++) {
        let doc = value[i];
        let time = doc.date_time.replace("/Date(", "").replace(")/", "");
        vm.statementlist.push({
          amount: doc.amount,
          orderid: doc.rechargeid,
          mobile: doc.transfer_mobile_no,
          time: time,
          remark: doc.remark,
          sender: doc.sender_name,
          name: doc.bank_beneficiary,
          account: doc.account_no,
          status: doc.status,
          bank_txtid: doc.bank_txid,
          user_name: doc.user_name,
          bank_name: doc.bank_name,
          bank_ifsc: doc.bank_ifsc,
          tid: doc.transaction_id,
          mobile_no: doc.mobile_no
        });
      }
    },
    getsummary(doc) {
      let vm = this;
      vm.viewstatus = true;
      vm.summary = doc;
      console.log(doc);
      // vm.summary = {
      //   "Order No": doc.orderid,
      //   "Name ": doc.name,
      //   Mobile: doc.mobile,
      //   Amount: doc.amount,
      //   Status: doc.status,
      //   Time: doc.time,
      //   "Bank Transaction Id": doc.bank_txtid,
      //   "Transaction Id": doc.tid
      // };
    },
    print() {
      let vm = this;
      const css = `
              @media print {
                body {-webkit-print-color-adjust: exact;}
              }
                .printer {
                  width:100%;
                  background:white;
                }
                .printer__header {
                  display:flex;
                  margin-bottom:20px;
                  justify-content: space-between;
                }
                .printer__image {
                  width: 100px;
                  height: 40px;
                  object-fit: contain;
                }
                .printer__title {
                  font-size: 2rem;
                  float: left;
                  margin:0px;
                  text-align: center;
                }
                .printer__table {
                  width: 100%;
                  border-collapse: collapse;
                }
                .printer__tr td{
                  padding: 10px!important;
                  font-size: 1.2em;
                }
                .printer__tr--title {
                  background:green;
                  font-weight:bold;
                  color:white;
                }
                .printer__table--border td {
                  border: 1px solid lightgrey;
                  margin-bottom: 10px;
                }`;
      const prtHtml = vm.$refs.print.innerHTML;
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style>
                    ${css}
                    </style>
                </head>
                <body>
                    <div class="printer">
                        ${prtHtml}
                    </div>
                </body>
                </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    },
    fetchstatement() {
      let vm = this;
      if (!vm.user.phone)
        return vm.notification("warn", "Authentication Required!");
      let mobile = vm.dmr != null ? vm.dmr.mobile_no : "";
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        recordcnt: "50",
        getFromdate: vm.date1,
        getTodate: vm.date2,
        Validate_MobileNo: vm.mobile
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "DMTF_History",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.dialog = false;
          vm.pushstatement(res.data);
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    }
  },
  mounted() {
    let vm = this;
    vm.fetchstatement();
  }
};
</script>


<style scoped>
.search {
  width: 150px;
  float: right;
  height: 34px;
  background: white;
  border: 1px solid lightgray;
  outline: none;
  margin-left: 20px;
  padding-left: 10px;
  font-size: 1em;
}
.searchbtn {
  margin-right: 15px;
  height: 34px;
  margin-left: 20px;
  float: right;
  margin-top: 0px;
}
.printer__container {
  background: white;
}
.printer {
  width: 100%;
  background: white;
  padding: 25px;
}
.printer__header {
  display: flex;
  justify-content: space-between;
}
.printer__image {
  width: 100px;
  height: 40px;
  float: left;
  object-fit: contain;
}
.printer__title {
  font-size: 2rem;
  float: left;
  text-align: center;
}
.printer__table {
  width: 100%;
  border-collapse: collapse;
}
.printer__tr td {
  padding: 10px !important;
  font-size: 1.2em;
}
.printer__tr--title {
  background: green;
  font-weight: bold;
  color: white;
}
.printer__table--border td {
  border: 1px solid lightgrey;
  margin-bottom: 10px;
}
.printer__footer {
  display: flex;
  padding-right: 15px;
  padding-bottom: 15px;
}
</style>

